export class Video{

    public id: string;

    public title: string;

    public description: string;

    public thumbnail_url: string;

    public views: number;

    public likes: number;
    
    public dislikes: number;

    public publishedAt: string;

    public channelId: string;

    public channelTitle;

    public commentCount: number;

    public channelThumbnailUrl: string;

    public duration: string;

    public categoryId: string;

    public category: string;

}


// WEBPACK FOOTER //
// ./src/app/video.ts